import { Stack, Typography, } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const NotfoundPage = () => {
    return (
        <Stack direction='column' justifyContent='center' alignItems='center' sx={{height: '100%'}}>
            <SearchOffIcon sx={{fontSize: [70, 80, 90, 100]}} />
            <Typography sx={{color: 'text.primary', fontSize: [33, 36, 39, 42], textAlign: 'center', }}>Страница не найдена</Typography>
        </Stack>
    )
};

export default NotfoundPage;